import { useEffect } from 'react';

import { useGetAccounts, useGetContext } from '@api/lendingAPI/lapiHooks';
import formbricks from '@formbricks/js';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';

import { AwaitingFundsIllustrationSVG } from '../../../svgComponents/awaitingFundsIllustrationSVG';
import { StateView } from '../../pageStructure/stateView/StateView';

export const AwaitingFundsView = () => {
    const { data: accounts } = useGetAccounts();
    const { data: contextData } = useGetContext();
    const loggedInUserType = contextData?.logged_in_user_type;

    useEffect(() => {
        if (getCountry() !== 'DE') return;
        if (loggedInUserType !== 'customer') return;
        if (!accounts) return;

        const hadPreviousLoan = accounts.accounts.some((a) => a.account_id);

        formbricks.setAttribute('had_previous_loan', String(hadPreviousLoan));
        formbricks.track('awaiting-funds-view-shown');
    }, [loggedInUserType, accounts]);

    return (
        <StateView
            image={<AwaitingFundsIllustrationSVG />}
            headerMessage={
                <FormattedMessage
                    id="_.awaiting_funds_view.title"
                    defaultMessage="Your funds are on their way!"
                />
            }
            descriptionMessage={
                <FormattedMessage
                    id="_.awaiting_funds_view.subtitle"
                    defaultMessage="Thank you for completing your application, we're processing the transfer of funds and they'll land in your account as soon as we've processed the transfer."
                />
            }
        />
    );
};
